<div
  class="user-group d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 mb-5 w-100">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <h1 class="modal-title m-auto">{{ 'GROUPS' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>
  <div
    class="d-flex flex-column justify-content-start w-100 form-container"
  >
    <div class="listing">
      <div class="scroll-container">
        <ng-container
          *ngFor="
            let group of userGroupList | sortBy : 'userGroupName' : 'asc';
            let i = index
          "
        >
          <div class="form-group rounded-top form-container">
            <div
              class="form-group rounded-top form-container"
              [id]="group?.userGroupId"
              (click)="editGroup(group)"
            >
              <div class="w-100 building-list-container">
                <div class="d-flex list-box full pointer-cursor mr-2">
                  <span class="align-self-center">
                    <img
                      alt="User Icon"
                      src="assets/svg/ico-lock-user-access-circle.svg"
                      class="left-icon"
                    />
                  </span>
                  <span class="title bold align-self-center">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ group.userGroupName }}
                    </app-with-tooltip>
                  </span>

                  <span class="selected-value-container align-self-center">
                    <span class="btn-not-text">
                      <button
                      mat-icon-button aria-label="state icon"
                        class="icon-button"
                        type="button"
                        (click)="editGroup(group)"
                      >
                        <img 
                          [src]="
                          group.active
                            ? 'assets/svg/ico-checkmark-circle-outline.svg'
                            : 'assets/svg/ico-circle.svg'
                        "
                        />
                      </button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
 
      </div>
      <ng-container>
        <div class="row">
          <div class="col-12 my-1">
            <button
              class="btn btn-danger px-3 w-100 btn-submit"
              (click)="submitGroup(userGroupList)"
            >
              {{ 'SAVE' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
